import React from 'react';
import { Box, Container, Paper, useMediaQuery, useTheme } from '@mui/material';
import { ManualBookingProvider } from '../../context/ManualBookingContext';
import BookingStepper from './steps/BookingStepper';
import LocationStep from './steps/LocationStep';
import ServiceStep from './steps/ServiceStep';
import ServiceOptionsStep from './steps/ServiceOptionsStep';
import DateStep from './steps/DateStep';
import StaffStep from './steps/StaffStep';
import TimeStep from './steps/TimeStep';
import CustomerStep from './steps/CustomerStep';
import ConfirmationStep from './steps/ConfirmationStep';
import { useNavigate, useLocation } from 'react-router-dom';

const ManualBookingContent = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  // NOTE: Stepper is currently hidden by default. See steps/stepper-visibility.md
  const [showStepper, setShowStepper] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const searchParams = new URLSearchParams(location.search);
  const returnTo = searchParams.get('returnTo') || '/app/overview';

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      // If on first step, navigate back to the return path
      navigate(returnTo);
      return;
    }
    setActiveStep((prevStep) => Math.max(0, prevStep - 1));
  };

  const handleStepClick = (stepIndex) => {
    // Allow navigation to completed steps
    if (stepIndex < activeStep) {
      setActiveStep(stepIndex);
    }
  };

  const handleSuccess = (data) => {
    navigate('/app/overview/book/success', {
      state: data,
      replace: true,
    });
  };

  const steps = [
    {
      label: 'Choose Location',
      component: <LocationStep onNext={handleNext} onBack={handleBack} />
    },
    {
      label: 'Select Service',
      component: <ServiceStep onNext={handleNext} onBack={handleBack} />
    },
    {
      label: 'Service Options',
      component: <ServiceOptionsStep onNext={handleNext} onBack={handleBack} />
    },
    {
      label: 'Choose Date',
      component: <DateStep onNext={handleNext} onBack={handleBack} />
    },
    {
      label: 'Choose Staff',
      component: <StaffStep onNext={handleNext} onBack={handleBack} />
    },
    {
      label: 'Choose Time',
      component: <TimeStep onNext={handleNext} onBack={handleBack} />
    },
    {
      label: 'Customer Info',
      component: <CustomerStep onNext={handleNext} onBack={handleBack} />
    },
    {
      label: 'Confirm',
      component: <ConfirmationStep onBack={handleBack} onSuccess={handleSuccess} />
    }
  ];

  return (
    <Container maxWidth="md" sx={{ py: 2 }}>
      {/* BookingStepper is currently hidden by default. 
          To show it, set showStepper state to true.
          See docs/manual-booking/stepper-visibility.md for details. */}
      {showStepper && (
        <Box sx={{ mb: 2 }}>
          <BookingStepper 
            activeStep={activeStep} 
            isMobile={isMobile} 
            onStepClick={handleStepClick}
          />
        </Box>
      )}
      
      {steps[activeStep].component}
    </Container>
  );
};

// Wrap the content with the ManualBookingProvider
const ManualBookingPage = () => {
  return (
    <ManualBookingProvider>
      <ManualBookingContent />
    </ManualBookingProvider>
  );
};

export default ManualBookingPage; 